import { Select } from "antd";
const { Option } = Select;

export const generateCountries = arr => {
  return arr.map(country => (
    <Option key={country.code2} value={country.code2}>
      {country.name}
    </Option>
  ));
};

export const generateOptions = arr => {
  return arr.map(option => (
    <Option key={option.name} value={option.name}>
      {option.name}
    </Option>
  ));
};

export const generateZones = arr => {
  return arr.map(option => (
    <Option key={option.cmp_id} value={option.cmp_id}>
      {option.title}
    </Option>
  ));
};

export const generateApps = arr => {
  return arr.map(option => (
    <Option key={option.app} value={option.app}>
      {option.domain}
    </Option>
  ));
};
